import styled from 'foundations-theming/utils';
export const InterstitialTileTitle = styled.div.withConfig({
  displayName: "SharedComponents__InterstitialTileTitle",
  componentId: "sc-1pgzyth-0"
})(["font-weight:600;font-size:20px;"]);
export const StyledTitleContainer = styled.span.withConfig({
  displayName: "SharedComponents__StyledTitleContainer",
  componentId: "sc-1pgzyth-1"
})(["margin-bottom:8px;"]);